// Packages
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const GRecaptcha = forwardRef(({ onVerify }, ref) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleTokenChange = async () => {
    if (!executeRecaptcha) {
      return;
    }

    const token = await executeRecaptcha("g_recaptcha_action");
    onVerify && onVerify(token);
  };

  useEffect(() => {
    handleTokenChange().then((r) => r);

    const interval = setInterval(() => {
      handleTokenChange().then((r) => r);
    }, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, [executeRecaptcha !== undefined]);

  useImperativeHandle(ref, () => ({
    refreshAsync: handleTokenChange,
  }));

  return null;
});

GRecaptcha.displayName = "GRecaptcha";
export default GRecaptcha;
